import React from 'react';

import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';
import {Body} from 'shells/typography/body';

import type {FormattedOption} from '../helpers';

import styles from '../security-page.module.css';

type Props = {
    nonDefaultRoles: Array<FormattedOption>;
    defaultRole: FormattedOption | null | undefined;
    handleDefaultRoleChange: (selectedRole: FormattedOption) => void;
};

export function DirectorySyncDefaultRole(props: Props) {
    return (
        <div className='flex flex-dir-col gap-8'>
            <Body size='small' isBold={true} color='medium'>
                Assign a default role for all new users added from this Active Directory
            </Body>
            <div className={styles['sso-input-container']}>
                <SelectPickerGeneric
                    options={props.nonDefaultRoles}
                    // @ts-expect-error
                    onChange={(selectedRole) => {
                        props.handleDefaultRoleChange(selectedRole);
                    }}
                    value={props.defaultRole}
                    placeholder='Select a role'
                />
            </div>
            <Body size='small' color='medium'>
                All users provisioned into Nutshell via Active Directory will not have a license.
                They will need to be assigned one manually.
            </Body>
        </div>
    );
}
